export const NC_EVT = {
  VIEW_CONFIRM_DETAILS_PAGE: "view_bnpl_confirm_details_page",
  ACT_CONFIRM_DETAILS_CONTINUE: "act_bnpl_confirm_details_continue",
  VIEW_ADDITIONAL_DETAILS_PAGE: "view_bnpl_additional_details_page",
  ACT_ADDITIONAL_DETAILS_SUBMIT: "act_bnpl_additional_details_submit",
  VIEW_CONSENT_PAGE: "view_bnpl_consent_page",
  ACT_CONSENT_PROCEED: "act_bnpl_consent_proceed",
  OUTCOME_REG_SUCCESS: "outcome_bnpl_reg_success",
  OUTCOME_REG_FAILED: "outcome_bnpl_reg_failed",
  OUTCOME_BNPL_MAINTENANCE: "outcome_bnpl_maintenance",
};
